type TwitterPixelPayload = Record<string, unknown>

const {
  VITE_TWITTER_PIXEL_PAGE_VIEW_EVENT_ID,
  VITE_TWITTER_PIXEL_DEPOSIT_EVENT_ID,
} = import.meta.env

const DEFAULT_PAGE_VIEW_EVENT_ID = 'tw-qkipf-qkipf'

const PAGE_VIEW_EVENT_ID =
  VITE_TWITTER_PIXEL_PAGE_VIEW_EVENT_ID?.trim() || DEFAULT_PAGE_VIEW_EVENT_ID
const DEPOSIT_EVENT_ID = VITE_TWITTER_PIXEL_DEPOSIT_EVENT_ID?.trim() || undefined

const isBrowser = typeof window !== 'undefined'

function withTwitterPixel(callback: (twq: (...args: any[]) => void) => void): void {
  if (!isBrowser) {
    return
  }

  const { twq } = window
  if (typeof twq === 'function') {
    callback(twq)
  }
}

function dispatchTwitterEventById(eventId: string | undefined, payload: TwitterPixelPayload = {}) {
  if (!eventId) {
    return
  }

  withTwitterPixel((twq) => {
    try {
      twq('event', eventId, payload)
    } catch (error) {
      console.warn('Failed to emit Twitter Pixel event by id', { eventId, error })
    }
  })
}

export function fireTwitterPageView(payload: TwitterPixelPayload = {}) {
  dispatchTwitterEventById(PAGE_VIEW_EVENT_ID, payload)
}

export function fireTwitterDepositModalOpened(payload: TwitterPixelPayload = {}) {
  dispatchTwitterEventById(DEPOSIT_EVENT_ID, payload)
}

/**
 * Track Twitter deposit success conversion
 * Use when user completes a deposit
 */
export function fireTwitterDepositSuccess(payload: TwitterPixelPayload = {}) {
  // Track as a conversion event
  withTwitterPixel((twq) => {
    try {
      twq('track', 'Purchase', payload)
    } catch (error) {
      console.warn('Failed to emit Twitter Pixel deposit success event', { error })
    }
  })
}

export function trackTwitterEvent(eventName: string, payload: TwitterPixelPayload = {}) {
  if (!eventName) {
    return
  }

  withTwitterPixel((twq) => {
    try {
      twq('track', eventName, payload)
    } catch (error) {
      console.warn('Failed to emit Twitter Pixel event', { eventName, error })
    }
  })
}
